import axios from 'axios';

let _apiUrl = process.env.REACT_APP_API_URL || '/backend';
// If it's a relative URL and we are running locally on localhost, point to the backend port
if (_apiUrl.startsWith('/') && window.location.hostname === 'localhost') {
    _apiUrl = 'http://localhost:5001' + _apiUrl;
}
export const API_URL = _apiUrl;

const API = axios.create({
 baseURL: `${API_URL}/api`,
 headers: { 'Content-Type': 'application/json' }
});

export const UPLOADS_URL = `${API_URL}/uploads`;

export default API;
